import * as yup from "yup";
import { WallboxFormValues, WallboxTypes } from "src/pages/Wallbox";

export const wallboxFormSchema: yup.ObjectSchema<WallboxFormValues> =
  yup.object({
    wallboxInstalled: yup
      .mixed<WallboxTypes>()
      .notOneOf(["" as WallboxTypes.BLANK], "page.wallbox.formError.required"),
  });
